import type { Expense } from 'modules/invoicing/expenses/types';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useSessionScope } from 'services';
import { Card, Table, Tbody, Td, Tr } from '@ff-it/ui';

export default function ImportedBlocks({ expense }: { expense: Expense }): ReactNode {
  const matchingBlocks = expense.matching_blocks || [];
  const { slug } = useSessionScope();

  if (matchingBlocks.length === 0) {
    return null;
  }

  return (
    <Card.Container testId="imported-blocks" mb="3" width="full">
      <Card.Header>Imported blocks</Card.Header>
      <Table size="xs" fixed>
        <Tbody>
          {matchingBlocks.map((block) => (
            <Tr key={block.id}>
              <Td>
                <Link to={`/${slug}/planning/campaigns/${block.campaign_id}/planning/${block.id}`} target="_blank">
                  {block.code}
                </Link>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Card.Container>
  );
}
